/**
 * Bipo Look Up Module — AJAX Form Handler
 *
 * Intercepts the #bipo-look-up-form submit event, validates the Business Name
 * and Postcode fields client-side, then sends a POST request to the WordPress
 * AJAX endpoint (wp_ajax_nopriv_bipo_lookup).
 *
 * On success, renders found agreements or a no-match message with sign-up links
 * into #bipo-look-up-results. On failure, shows an error banner.
 *
 * Dependencies: jQuery (loaded via wp_enqueue_script with 'jquery' as a dep).
 */
(function ($) {
	'use strict';

	$(document).ready(function () {

		var $form = $('#bipo-look-up-form');

		if (!$form.length) {
			return;
		}

		$form.on('submit', function (e) {
			e.preventDefault();

			var ajaxUrl  = $form.data('ajax-url');
			var restUrl  = $form.data('rest-url');
			var nonce    = $form.data('nonce');
			var $btn     = $('#bipo-look-up-btn');
			var $results = $('#bipo-look-up-results');
			var company  = $('#bipo-company-name').val().trim();
			var postcode = $('#bipo-postcode').val().trim();

			clearErrors();
			$results.removeAttr('hidden').empty();

			// If both fields are empty, show no-results immediately — no round-trip needed.
			if (!company && !postcode) {
				renderResults($results, { found: false, rac_link: '/create-new-rac-grower-agreement/', koep_link: '/koep-registration/' });
				return;
			}

			// Validate postcode format only when a value is provided.
			if (postcode && !isValidPostcode(postcode)) {
				showFieldError('bipo-postcode-error', 'bipo-postcode', 'Enter valid postcode with space (e.g. SW1A 1AA).');
				$results.attr('hidden', '');
				return;
			}

			// Show loading state
			$btn.prop('disabled', true).text('Looking up…');
			$results.removeAttr('hidden').html(
				'<p class="bipo-look-up__results-loading">Searching, please wait…</p>'
			);

			// Fetch a fresh nonce to survive page caching, then do the lookup.
			$.getJSON( restUrl + 'bipo/v1/nonce/bipo_lookup_nonce' )
				.always( function ( data ) {
					if ( data && data.nonce ) {
						nonce = data.nonce;
					}
					$.ajax({
						url  : ajaxUrl,
						type : 'POST',
						data : {
							action         : 'bipo_lookup',
							nonce          : nonce,
							companylookup  : company,
							postcodelookup : postcode,
						},
						success: function (response) {
							$btn.prop('disabled', false).text('Look up');
							if (response.success) {
								renderResults($results, response.data);
							} else {
								$results.html(
									'<div class="bipo-look-up__results-error">' +
									escapeHtml(response.data.message) +
									'</div>'
								);
							}
						},
						error: function () {
							$btn.prop('disabled', false).text('Look up');
							$results.html(
								'<div class="bipo-look-up__results-error">' +
								'An unexpected error occurred. Please try again.' +
								'</div>'
							);
						},
					});
				});
		});

		/**
		 * Render the AJAX response data into the results container.
		 *
		 * Found matches are displayed in a UIKit striped table with three columns:
		 * Business Name, Agreement Type, and Agreement Reference.
		 *
		 * @param {jQuery} $results - The results container element.
		 * @param {Object} data     - Decoded JSON from the AJAX handler.
		 */
		function renderResults($results, data) {
			var html = '';

			if (data.found && data.matches.length) {
				html  = '<div class="bipo-look-up__results-success">';
				html += '<p><strong>RAC / KWS KOEP Agreements found</strong></p>';
				html += '<div class="uk-overflow-auto">';
				html += '<table class="uk-table uk-table-striped uk-table-small uk-table-divider">';
				html += '<thead><tr>';
				html += '<th>Business Name</th>';
				html += '<th>Agreement Type</th>';
				html += '<th>Reference</th>';
				html += '</tr></thead>';
				html += '<tbody>';

				$.each(data.matches, function (_, match) {
					html += '<tr>' +
						'<td>' + escapeHtml(match.company_name) + '</td>' +
						'<td>' + escapeHtml(match.type) + '</td>' +
						'<td><strong>' + escapeHtml(match.nickname) + '</strong></td>' +
						'</tr>';
				});

				html += '</tbody></table>';
				html += '</div>';
				html += '</div>';
			} else {
				html = '<div class="bipo-look-up__results-no-match">' +
					'<p>No matches found. Contact the BIPO office or:</p>' +
					'<p><a href="' + escapeHtml(data.rac_link) + '">Sign a new RAC Growers Agreement</a></p>' +
					'<p><a href="' + escapeHtml(data.koep_link) + '">Sign a new KWS Oilseed Establishment Partnership (KOEP) Agreement</a></p>' +
					'</div>';
			}

			$results.html(html);
		}

		/**
		 * Show an error message beneath a form field and mark it as invalid.
		 *
		 * @param {string} errorId  - ID of the error <span> element.
		 * @param {string} inputId  - ID of the input element to mark invalid.
		 * @param {string} message  - Error text to display.
		 */
		function showFieldError(errorId, inputId, message) {
			$('#' + errorId).text(message).removeAttr('hidden');
			$('#' + inputId).addClass('uk-form-danger');
		}

		/**
		 * Clear all field-level validation errors and input danger states.
		 */
		function clearErrors() {
			$('.bipo-look-up__error').text('').attr('hidden', '');
			$('.bipo-look-up__input').removeClass('uk-form-danger');
		}

		/**
		 * Validate a UK postcode format — requires a space (e.g. "SW1A 1AA").
		 *
		 * @param  {string}  value - Postcode string to validate.
		 * @return {boolean}
		 */
		function isValidPostcode(value) {
			return /^[a-zA-Z]{1,2}\d[a-zA-Z0-9]?\s\d[a-zA-Z]{2}$/i.test(value);
		}

		/**
		 * Escape HTML special characters to prevent XSS in injected content.
		 *
		 * @param  {string} str - Raw string to escape.
		 * @return {string}     - HTML-safe string.
		 */
		function escapeHtml(str) {
			return String(str)
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;')
				.replace(/'/g, '&#039;');
		}
	});

}(jQuery));
